export enum MenuIds {
    AuditCreate = 'menu-audit-create',
    AuditList = 'menu-audit-list',
    Dashboard = 'menu-dasboard',
    Materials = 'menu-materials',
    Messages = 'menu-messages',
    NonConformities = 'menu-non-conformities',
    Settings = 'menu-settings',
    SettingsAccount = 'menu-settings-account',
    SettingsUsers = 'menu-settings-users',
    SettingsCompanies = 'menu-settings-companies',
    SettingsOrganizationalUnits = 'menu-setting-org-units',
    SettingsStandardsTypes = 'menu-settings-standards-types',
    SettingsStandards = 'menu-settings-standards',
    Subscriptions = 'menu-subscriptions',
    SubscriptionsLicense = 'menu-subscriptions-license',
    Suppliers = 'menu-suppliers',
}
